import { getProjectList, gainIndexUser } from '@/api/api.js'
export default {
    async getProjectList(context, params){  //获取项目列表
        const res =  await getProjectList({
            params
        });
        context.commit('getProjectList',res.data.data)
    },

    // async gainIndexUser(context, params){
    //     const res=await gainIndexUser({
    //         params
    //     })
    //     context.commit('setInfo', params)
    // }

}


// WEBPACK FOOTER //
// ./src/store/actions.js